import { useEffect, useRef } from 'react';

export default function useInterval(callback: AnyFunction, delay: number, executeImmediately?: boolean): void {
    const savedCallback = useRef(null);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (delay !== null) {
            if (executeImmediately) {
                savedCallback.current();
            }

            const id = setInterval(() => {
                savedCallback.current();
            }, delay);

            return () => clearInterval(id);
        }

        return () => {
            // do nothing
        };
    }, [delay]);
}
